import styled from "styled-components";

import rightArrowIcon from "../../../../assets/Mayo/small_blue_arrow.svg"

export default function Disclosure({ title, children, defaultOpen = false, open, openFunc }) {
  return (
    <Container>
      <Header
        aria-expanded={open}
        onClick={openFunc} 
      >
        <Title>{title}</Title>
        <Icon
          $open={open} 
          src={rightArrowIcon}
        />
      </Header>

      <Panel $open={open} role="region" aria-hidden={!open}>
        <PanelInner>{children}</PanelInner>
      </Panel>

      <HL/>
    </Container>
  );
}


const Container = styled.div``;

const Header = styled.div`
  display: flex;
  justify-content: space-between;  /* arrow on the right */
  margin-block: 21px;
`;

const Title = styled.span`
  text-align: left;
  font-family: Abraham, Medium;
  font-weight: 500;
  font-size: 19px;
`;

const Arrow = styled.span`
  /* transition: transform 0.2s ease; */
  `;

const Panel = styled.div`
  /* smooth expand/collapse without measuring height */
  display: grid;
  grid-template-rows: ${(p) => (p.$open ? "1fr" : "0fr")};
  transition: grid-template-rows 220ms ease;
  margin-bottom: ${(p) => (p.$open ? "21px" : "0px")};
  `;

const PanelInner = styled.div`
  overflow: hidden;
  color: #1A1A1A;
  text-align: left;
  font-family: Abraham, Medium;
  font-weight: 400;
  font-size: 19px;
  `;

const Icon = styled.img`
  display: inline-flex;
  transform: rotate(${(p) => (p.$open ? 90 : 0)}deg);
  width: 7px;
  height: 13px;
  margin-top: 5px;
`

const HL = styled.div`
  height: 1px;
  background-color: #CCD9FB;
`